// -- Import your pages here..
const AMHome = () => import('@/views/drs/ai-model/AMHome')
const AMLists = () => import('@/views/drs/ai-model/AMLists')
const AMCreate = () => import('@/views/drs/ai-model/AMCreate')
const AMEdit = () => import('@/views/drs/ai-model/AMEdit')

export default 
{   
    path: '/:orgName/drs/ai-model', 
    name: 'AI Model', 
    redirect: '/:orgName/drs/ai-model',
    component: AMHome,
    children: [
        {
            path: '/:orgName/drs/ai-model', 
            name: 'AI Model Index', 
            meta: { label: "Index", auth: true, slug: 'ai-model-list'},
            component: AMLists,
        },
        {
            path: '/:orgName/drs/ai-model/create', 
            name: 'AI Model Create', 
            meta: { label: "Create", auth: true, slug: 'create-ai-model'},
            component: AMCreate,
        },
        {
            path: '/:orgName/drs/ai-model/:id', 
            name: 'AI Model Edit', 
            meta: { label: "View", auth: true, slug: 'view-ai-model'},
            component: AMEdit,
        }
    ]
}